<template>
  <div class="v-full vpanel vh-flex card-shadow">
    <EmptyView v-if="selectUnit == null" text="未选择课程"></EmptyView>
    <div v-else class="vh-full vh-flex">
      <div class="vftop">
        <RoundGroupMenu @menuClick="menuClick" :menus="listMenus" :selectKey="selectMenuKey"></RoundGroupMenu>
      </div>
      <!--视图区域-->
      <component class="vh-full" :is="selectMenuKey" :bookInfo="bookInfo" :selectUnit="selectUnit"></component>
    </div>

  </div>
</template>

<script>
import EmptyView from '@/components/EmptyView.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import IconMenu from '@/components/IconMenu.vue';
import IconView from '@/components/IconView.vue';
import RoundGroupMenu from '@/components/RoundGroupMenu.vue';
import UnitOverview from './overview/UnitOverview.vue';
import SentenceManager from './sentence/SentenceManager.vue';

export default {
  name: 'BookDetailsRightPanel',
  components: {
    EmptyView,
    SvgIcon,
    IconMenu,
    IconView,
    RoundGroupMenu,
    UnitOverview,
    SentenceManager
  },
  props: {
    bookInfo: Object,
    selectUnit: {
      type: Object,
      default: null
    }
  },
  watch: {
    selectUnit: function (nval, old) {

    }
  },
  data() {
    return {
      listMenus: [
        { name: "概览", key: "UnitOverview" },
        { name: "句子", key: "SentenceManager" }
      ],
      selectMenuKey: "UnitOverview"
    }
  },
  mounted: function () {

  },
  methods: {
    ///菜单点击
    menuClick: function (item) {
      this.selectMenuKey = item.key
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vpanel {
  background: var(--ek-mainbody-bgcolor);
  border-radius: 15px;
  margin-bottom: 20px;
  margin-right: 30px;
}

.vftop {
  padding-top: 15px;
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--ek-split-lineColor);
}
</style>
